import { useMemo } from "react";
import type { TurningPoint } from "@/lib/narrative/turningPointDetector";
import { getTurningPoints } from "@/lib/narrative/turningPointDetector";

// Thin wrapper: accepts timeline state snapshot and returns memoized turning points.
export function useNarrativeReadModel(snapshot: unknown): TurningPoint[] {
  // snapshot is expected to be the timeline state object (can be large)
  return useMemo(() => {
    try {
      const s: any = snapshot ?? {};
      const snap = {
        durationSec: Number(s?.durationSec ?? s?.timeline?.durationSec ?? null),
        clips: Array.isArray(s?.clips) ? s.clips : Array.isArray(s?.timeline?.clips) ? s.timeline.clips : [],
        markers: Array.isArray(s?.markers) ? s.markers : [],
        ranges: Array.isArray(s?.ranges) ? s.ranges : [],
      } as any;

      return getTurningPoints(snap as any);
    } catch {
      return [] as TurningPoint[];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(snapshot ?? {})]);
}

export default useNarrativeReadModel;
